if (!customElements.get('bb-personalizer')) customElements.define('bb-personalizer', class extends HTMLElement {
  connectedCallback() {
    this.form = this.closest('form');
    this.fields = this.querySelector('fieldset');
    this.variants = JSON.parse(this.querySelector('script').textContent);
    this.changeHandler = () => this.update();
    this.form.addEventListener('change', this.changeHandler);
    this.addEventListener('input', this.changeHandler);
    this.update();
  }
  disconnectedCallback() { this.form?.removeEventListener('change', this.changeHandler); }
  update() {
    const variant = this.variants.find(v => String(v.id) === this.form.querySelector('[name="id"]').value);
    const enabled = this.dataset.optional !== 'true' || variant?.options.includes('Yes');
    this.fields.disabled = !enabled;
    this.hidden = !enabled;
    const design = this.querySelector('[data-design]')?.value || '';
    const custom = design.startsWith('9 ');
    this.querySelector('[data-standard-fields]').hidden = custom;
    this.querySelectorAll('[data-standard-fields] input').forEach(el => el.disabled = custom);
    this.querySelector('[data-artwork-fields]').hidden = !custom;
    this.querySelectorAll('[data-artwork-fields] input, [data-artwork-fields] textarea').forEach(el => el.disabled = !custom);
    const initial = /^(2|4) /.test(design);
    this.querySelector('[data-initial-field]').hidden = !initial || custom;
    this.querySelector('[data-initial]').disabled = !initial || custom;
    this.querySelector('[data-initial]').required = initial && !custom;
    const wording = custom ? this.querySelector('[data-arttext]').value : this.querySelector('[data-wording]').value;
    this.querySelector('[data-wording-preview]').textContent = wording || this.querySelector('[data-artfile]').files[0]?.name || 'Enter your wording above to review it here.';
    this.querySelector('[data-arttext]').setCustomValidity('');
    this.querySelector('[data-artfile]').setCustomValidity('');
    this.querySelector('[data-wording]').setCustomValidity('');
  }
  validate() {
    this.update();
    if (this.fields.disabled) return true;
    const text = this.querySelector('[data-arttext]');
    const file = this.querySelector('[data-artfile]');
    const wording = this.querySelector('[data-wording]');
    if (!wording.disabled && !wording.value.trim()) wording.setCustomValidity('Please enter the wording you want engraved.');
    if (!text.disabled && !text.value.trim() && !file.files.length) text.setCustomValidity('Enter your custom text or upload your artwork.');
    if (!file.disabled && file.files.length && (file.files[0].size > 10 * 1024 * 1024 || !/\.(png|jpe?g|pdf)$/i.test(file.files[0].name))) file.setCustomValidity('Please use a JPG, PNG or PDF file under 10 MB.');
    return this.form.reportValidity();
  }
});
if (!customElements.get('bb-color-gallery')) customElements.define('bb-color-gallery', class extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', event => {
      const button = event.target.closest('button[data-image]');
      if (!button) return;
      this.querySelector('[data-main-image]').src = button.dataset.image;
      this.querySelector('[data-main-image]').alt = button.dataset.alt;
      this.querySelector('[data-zoom]').href = button.dataset.image;
      this.querySelectorAll('button[data-image]').forEach(el => el.setAttribute('aria-pressed', String(el === button)));
    });
  }
});
if (!customElements.get('bb-gift-grid')) customElements.define('bb-gift-grid', class extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', event => {
      const button = event.target.closest('[data-filter]');
      if (!button) return;
      this.querySelectorAll('[data-filter]').forEach(el => el.setAttribute('aria-pressed', String(el === button)));
      this.querySelectorAll('[data-category]').forEach(el => el.hidden = button.dataset.filter !== 'all' && el.dataset.category !== button.dataset.filter);
    });
  }
});

/* Bambusi extras: gift add-ons, order note sync for fulfillment, hover zoom */
(function () {
  if (window.__bbExtras) return;
  window.__bbExtras = true;
  const nativeFetch = window.fetch.bind(window);

  /* Order note sync. Copies personalization and gift details into the order note
     so they reach fulfillment tools that do not import line item properties. */
  const MARK = '--- Personalization and gift details (auto) ---';
  let syncTimer = null;
  let syncing = false;
  async function syncNote() {
    if (syncing) return;
    syncing = true;
    try {
      const cart = await (await nativeFetch('/cart.js', { credentials: 'same-origin' })).json();
      const lines = [];
      cart.items.forEach(item => {
        const props = item.properties || {};
        const keys = Object.keys(props).filter(k => !k.startsWith('_') && k !== 'Spelling confirmed' && props[k] !== null && String(props[k]).trim() !== '');
        if (!keys.length) return;
        lines.push(`${item.sku || 'NO SKU'} | ${item.product_title}${item.variant_title ? ' (' + item.variant_title + ')' : ''} | Qty ${item.quantity}`);
        keys.forEach(k => lines.push(`  ${k}: ${String(props[k]).replace(/\s+/g, ' ').trim()}`));
      });
      const current = cart.note || '';
      const customer = current.split(MARK)[0].trim();
      const note = lines.length ? (customer ? customer + '\n\n' : '') + MARK + '\n' + lines.join('\n') : customer;
      if (note !== current) {
        await nativeFetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note })
        });
        document.querySelectorAll('textarea[name="note"]').forEach(el => { el.value = note; });
      }
    } catch (e) {
      /* never block shopping */
    } finally {
      syncing = false;
    }
  }
  function queueSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncNote, 400);
  }
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const result = nativeFetch(input, init);
    if (/\/cart\/(add|change|update|clear)/.test(url)) result.then(queueSync, () => {});
    return result;
  };
  document.addEventListener('DOMContentLoaded', () => {
    if (/^\/cart\/?$/.test(location.pathname) || /^\/checkout/.test(location.pathname)) syncNote();
  });
  /* Gift add-ons. Checked add-ons are added to the cart right before the main item. */
  document.addEventListener('change', event => {
    const box = event.target.closest && event.target.closest('[data-bb-addons]');
    if (!box || !event.target.matches('input[data-addon-toggle]')) return;
    const panel = box.querySelector(`[data-addon-panel="${event.target.dataset.addonToggle}"]`);
    if (panel) panel.hidden = !event.target.checked;
  });
  /* Buy it now skips the cart, so hide it while a gift add-on is checked. */
  document.addEventListener('change', event => {
    const box = event.target.closest && event.target.closest('[data-bb-addons]');
    if (!box) return;
    const scope = box.closest('section, .product, product-info') || document;
    const any = !!box.querySelector('input[data-addon-variant]:checked');
    scope.querySelectorAll('.shopify-payment-button').forEach(el => { el.style.display = any ? 'none' : ''; });
  });

  function addonBoxFor(form) {
    const scope = form.closest('section, .product, product-info') || document;
    return scope.querySelector('[data-bb-addons]');
  }

  function collectAddons(form, box) {
    const items = [];
    const data = new FormData(form);
    const qty = Math.max(1, parseInt(data.get('quantity') || '1', 10) || 1);
    const wording = (form.querySelector('[name="properties[Engraving wording]"]:not(:disabled)') || {}).value;
    const variantInput = form.querySelector('[name="id"]');
    let forLabel = box.dataset.for || '';
    const optionText = form.closest('section') && form.closest('section').querySelector('variant-selects input:checked, variant-selects select option:checked');
    if (optionText && optionText.value && optionText.value !== 'Default Title') forLabel += ` (${optionText.value})`;
    if (wording && wording.trim()) forLabel += ` | Engraving: ${wording.trim()}`;
    for (const cb of box.querySelectorAll('input[data-addon-variant]:checked')) {
      const props = { For: forLabel.slice(0, 250) };
      const panel = cb.dataset.addonToggle && box.querySelector(`[data-addon-panel="${cb.dataset.addonToggle}"]`);
      if (panel) {
        for (const field of panel.querySelectorAll('[data-addon-prop]')) {
          const value = field.value.trim();
          field.setCustomValidity(value ? '' : 'Please fill this in or uncheck the option.');
          if (!value) {
            panel.hidden = false;
            field.reportValidity();
            return null;
          }
          props[field.dataset.addonProp] = value;
        }
      }
      items.push({ id: Number(cb.dataset.addonVariant), quantity: cb.dataset.addonQty === 'match' ? qty : 1, properties: props });
    }
    if (variantInput && !variantInput.value) return [];
    return items;
  }

  let pendingKeys = [];
  let pendingAt = 0;
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (form.__bbAddonsDone) {
      form.__bbAddonsDone = false;
      return;
    }
    const box = addonBoxFor(form);
    if (!box || !box.querySelector('input[data-addon-variant]:checked')) return;
    const personalizer = form.querySelector('bb-personalizer');
    if (personalizer && typeof personalizer.validate === 'function' && !personalizer.validate()) return;
    const items = collectAddons(form, box);
    event.preventDefault();
    event.stopImmediatePropagation();
    if (items === null) return;
    const submitter = event.submitter || form.querySelector('[type="submit"]');
    if (submitter) submitter.classList.add('loading');
    try {
      const res = await nativeFetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      const json = await res.json();
      pendingKeys = (json.items || []).map(i => i.key);
      pendingAt = Date.now();
    } catch (e) {
      pendingKeys = [];
    }
    if (submitter) submitter.classList.remove('loading');
    /* Also write the add-ons onto the main item line so they show right on the item in the backend. */
    const temp = [];
    const addHidden = (name, value) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${name}]`;
      input.value = value;
      form.appendChild(input);
      temp.push(input);
    };
    const names = [...box.querySelectorAll('input[data-addon-variant]:checked')].map(cb => {
      const span = cb.closest('label') && cb.closest('label').querySelector('span');
      return span ? span.firstChild.textContent.trim() : '';
    }).filter(Boolean);
    if (names.length) addHidden('Gift add-ons', names.join(', '));
    items.forEach(item => {
      Object.keys(item.properties).forEach(key => { if (key !== 'For') addHidden(key, item.properties[key]); });
    });
    setTimeout(() => temp.forEach(el => el.remove()), 3000);
    form.__bbAddonsDone = true;
    if (form.requestSubmit) form.requestSubmit(submitter && submitter.form === form ? submitter : undefined);
    else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  }, true);

  /* If the main item fails to add, take the add-ons back out of the cart. */
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof window.subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    window.subscribe(PUB_SUB_EVENTS.cartError, async () => {
      if (!pendingKeys.length || Date.now() - pendingAt > 20000) return;
      const keys = pendingKeys;
      pendingKeys = [];
      for (const key of keys) {
        try {
          await nativeFetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          });
        } catch (e) {}
      }
      queueSync();
    });
    window.subscribe(PUB_SUB_EVENTS.cartUpdate, () => { pendingKeys = []; });
  });

  /* Hover zoom on product images (mouse only). Click still opens the full screen view. */
  if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    let active = null;
    const reset = el => {
      const img = el.querySelector('.product__media img');
      if (img) { img.style.transform = ''; img.style.transformOrigin = ''; }
      el.classList.remove('bb-zooming');
    };
    document.addEventListener('mousemove', event => {
      const box = event.target.closest && event.target.closest('.product__media-list .product-media-container.media-type-image');
      if (active && active !== box) { reset(active); active = null; }
      if (!box) return;
      const img = box.querySelector('.product__media img');
      if (!img) return;
      const r = box.getBoundingClientRect();
      const x = Math.min(100, Math.max(0, ((event.clientX - r.left) / r.width) * 100));
      const y = Math.min(100, Math.max(0, ((event.clientY - r.top) / r.height) * 100));
      img.style.transformOrigin = `${x}% ${y}%`;
      img.style.transform = 'scale(2.2)';
      box.classList.add('bb-zooming');
      active = box;
    }, { passive: true });
    document.addEventListener('mouseout', event => {
      if (active && !active.contains(event.relatedTarget)) { reset(active); active = null; }
    });
  }
})();
